














































import {
    defineComponent,
    reactive,
    ref,
    computed,
    Ref,
    watch,
    onMounted,
} from '@vue/composition-api';
import { MessageMap } from '../const';
import { imMessages, currentImMessage, AuditMessageType } from '@/common/im';
import { handleErrorMessageToast } from '@/common/util';
import { format } from 'date-fns';

export default defineComponent({
    setup(props, context) {
        const category = computed(() => {
            return MessageMap[
                context.root.$route.params.category as keyof typeof MessageMap
            ];
        });
        const indexPath = computed(() => {
            return (
                `/platform/profile/message/${context.root.$route.params.category}` +
                `?pageNum=${context.root.$route.query.pageNum}`
            );
        });
        const msgDetail: Ref<AuditMessageType> = ref({
            content: '',
            contentType: 'TEXT_TYPE',
            digest: '',
            createTime: 0,
            operationList: [],
        });
        function initCurrentImMessage() {
            // @ts-ignore
            currentImMessage.value = imMessages.value.find((item) => {
                return (
                    item.rawMsg.seqId.toString() ===
                    context.root.$route.query.id
                );
            });
            try {
                // @ts-ignore
                msgDetail.value = JSON.parse(currentImMessage.value.text);
            } catch (e) {
                handleErrorMessageToast(e);
            }
        }
        watch(
            () => imMessages.value,
            (v) => {
                if (v.length) {
                    initCurrentImMessage();
                }
            },
        );
        onMounted(() => {
            if (imMessages.value.length) {
                initCurrentImMessage();
            }
        });

        return {
            category,
            indexPath,
            MessageMap,
            currentImMessage,
            msgDetail,
            imMessages,
            format,
        };
    },
});
